import Form from 'shared/migration-components/form';
import {Link} from 'react-router-dom';
import useFormInputs from 'shared/migration-components/form/util';
import logo from 'shared/assets/images/logo.png';
import darkLogo from 'shared/assets/images/logo-dark.png';

import {Card, Container, LinkText, Login, Content} from './styles';
import useRegister from 'modules/auth/hooks/use-register';

const Register: React.FC = () => {
  const {getInput} = useFormInputs();
  const theme = localStorage.getItem('theme');

  return (
    <Container>
      <Content>
        <Card>
          <img
            src={theme === 'dark' ? darkLogo : logo}
            style={{
              width: 180,
              height: 120,
              alignSelf: 'center',
              marginLeft: -20,
            }}
          />
          <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
            <Form
              inputs={[
                getInput({name: 'name'}),
                getInput({name: 'email'}),
                getInput({name: 'cpf'}),
                getInput({name: 'phone'}),
                getInput({name: 'password', secureText: true}),
              ]}
              translationKey="UserProps"
              onSubmit={useRegister}
              buttonProps={{
                title: 'Criar conta',
                widthMode: 'expand',
              }}
            />
          </div>
        </Card>
        <Login>
          Já tem uma conta?
          <Link to="/login">
            <LinkText> Entrar</LinkText>
          </Link>
        </Login>
      </Content>
    </Container>
  );
};

export default Register;
